import { dynamic } from '#/utils/dynamic';

export const DynamicErrorPage = dynamic(
  () => import('./ErrorPage').then((module) => ({ default: module.ErrorPage })),
  { strategy: 'always' },
);
